import { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
withBounds = (WrappedComponent) -> ({ event, props... }) ->

  elementRef = useRef(undefined)
  PADDING = 16
  [top, setTop] = useState('-9999px')
  [left, setLeft] = useState('-9999px')

  windowHeight = window.innerHeight
  windowWidth = window.innerWidth

  position = ->
    { clientX, clientY } = event
    width = elementRef.current.clientWidth
    height = elementRef.current.clientHeight

    if clientX + width > windowWidth
      setLeft(clientX - width)
    else
      setLeft(clientX)
    if clientY + height + PADDING > windowHeight
      setTop(windowHeight - height - PADDING)
    else
      setTop(clientY)

  useEffect(->
    position()
    ->
      setTop('-9999px')
      setLeft('-9999px')
  )

  ReactDOM.createPortal(
    <WrappedComponent {props...} ref={elementRef} style={{ top, left }} />,
    document.body
  )

export default withBounds
